var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'router-select_active': _vm.active,
    'router-select-view-wrap': true,
  },on:{"click":_vm.openView}},[(_vm.options.length)?_c('span',{staticClass:"router-select-text"},[_vm._v(_vm._s(_vm.valueShow))]):_c('span',{staticClass:"router-select-placeholder"},[_vm._v(_vm._s(_vm._placeholder))])])}
var staticRenderFns = []

export { render, staticRenderFns }